import { createRouter, RouterProvider } from '@tanstack/react-router';
import { PageLoading } from '@/components/ui+/PageLoading';
import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  // TanStack Router automatically wraps route components in <Suspense /> boundaries.
  defaultPendingComponent: PageLoading,
  defaultGcTime: 0,
  defaultPreload: false,
  context: {},
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export type RegisteredRouter = typeof router;

export const AppRouter = () => {
  return <RouterProvider defaultGcTime={0} defaultPreload={false} router={router} />;
};
